'use client';

import { FC } from 'react';
import Image from 'next/image';
import { Star } from 'lucide-react';
import { Rating } from 'hotdesk_typescript';
import { formatDistanceToNow } from 'date-fns';
import styles from './ReviewCard.module.scss';
export interface ReviewCardProps {
  review: Rating;
}
const getStars = (rating: number): boolean[] => {
  const count = Math.ceil(rating / 100 * 5);
  return Array.from({
    length: 5
  }, (_, i) => i < count);
};
const ReviewCard: FC<ReviewCardProps> = ({
  review
}) => {
  const image = review?.user?.profileImage;
  const firstName = review?.user?.firstName || '';
  const lastName = review?.user?.lastName || '';
  const name = lastName ? `${firstName} ${lastName}` : firstName;
  const initials = (firstName[0] || '').toUpperCase();
  const comment = (review?.notes?.ratingBreakdown as unknown as Record<string, string>)?.comment || '';
  const date = review?.createdAt;
  const stars = getStars(review?.rating || 0);
  return <div className={styles.card} data-sentry-component="ReviewCard" data-sentry-source-file="ReviewCard.tsx">
            <div className={styles.header}>
                <div className={styles.avatar}>
                    {image ? <Image src={image} width={48} height={48} alt={name} className={styles.avatarImg} /> : <span className={styles.avatarFallback}>{initials}</span>}
                </div>
                <div className={styles.info}>
                    {name && <h4 className={styles.name} dir="auto">{name}</h4>}
                    {date && <span className={styles.date}>
                            {formatDistanceToNow(new Date(date), {
            addSuffix: true
          })}
                        </span>}
                </div>
            </div>
            <div className={styles.stars}>
                {stars.map((active, i) => <Star key={i} size={20} fill={active ? '#000' : '#fff'} color="#000" strokeWidth={1.75} />)}
            </div>
            {comment && <p className={styles.comment}>{comment}</p>}
        </div>;
};
export default ReviewCard;